import { useSyncExternalStore } from 'react';
import { getCopy, subscribeToCopy, type Copy } from './index';

/**
 * The words and the formatters for the active language, re-read when it changes.
 *
 * For views. A model calls `text()` / `fmt()` directly — it has no render to subscribe to, and the
 * view that renders its output is subscribed here, which is what makes reading module state during a
 * model call safe rather than merely convenient.
 *
 * Its own module because `strings/index.ts` must stay React-free: `api/problem.ts` reads the catalogue
 * and is imported by a `node --test` file that takes no dependencies.
 */
export function useCopy(): Copy {
  return useSyncExternalStore(subscribeToCopy, getCopy, getCopy);
}
